<template>
    <div class="fifteen">
        <el-row type="flex"
                class="row-bg course "
                justify="center">
            <el-col :span="20"
                    :style="{height:innerheight + 'px'}">
                <el-col class="sinister"
                        :span="11">
                    <transition name="slide-fade"
                                v-for="(item,index) in leftlist"
                                :key="index">
                        <div v-if="show"
                             class="main">
                            <img class="car"
                                 src="@/assets/images/che.png">
                            <div class="word">
                                <p>{{item.yearDate |formatDatetext}}</p>
                                <p>{{item.content}}</p>
                                <!-- <img src="@/assets/images/fazhanlicheng.png"> -->
                            </div>
                        </div>
                    </transition>
                </el-col>
                <div class="Thread">
                    <span class="line"
                          v-for="(item) in numberlength"></span>
                </div>
                <el-col class="dexter"
                        :span="11">
                    <transition name="slide-fade"
                                v-for="(item, index) in rightlist"
                                :key="index">
                        <div v-if="show"
                             class="main">
                            <img class="car"
                                 src="@/assets/images/che.png">
                            <div class="word">
                                <p>{{item.yearDate|formatDatetext}}</p>
                                <p>{{item.content}}</p>
                                <!-- <img src="@/assets/images/fazhanlicheng.png"> -->
                            </div>
                        </div>
                    </transition>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { selecthistorybyyear } from "@/api/apiall";
export default {
    data() {
        return {
            innerheight: "600",
            leftlist: [],
            rightlist: [],
            show: false,
            numberlength: 1
        };
    },
    created() {
        setTimeout(() => {
            this.show = true;
        }, 500);
    },
    mounted() {},
    methods: {
        searchmain(data) {
            this.show = false;
            selecthistorybyyear(data).then(res => {
                if (res.status === 2000) {
                    this.leftlist = res.data.leftList;
                    this.rightlist = res.data.rightList;
                    this.numberlength =
                        this.leftlist.length + this.rightlist.length;
                    this.innerheight =
                        (this.leftlist.length + this.rightlist.length) * 260;
                    if (this.numberlength == 1) {
                        this.innerheight = 500;
                    } else if (this.numberlength == 2) {
                        this.innerheight = 600;
                    }
                    setTimeout(() => {
                        this.show = true;
                    }, 1500);
                } else {
                    this.innerheight = 300;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.fifteen {
    overflow: hidden;
    .course {
        .el-col {
            margin: 0 42px;
            position: relative;
        }
        .sinister {
            min-height: 500px;
            position: absolute;
            top: 0;
            right: 50%;
            box-sizing: border-box;
            border-right: 4px solid;
            border-image: linear-gradient(#fff, #8a8786, #fff) 1 10 1;
            .main {
                height: 500px;
                .car {
                    position: absolute;
                    right: -40px;
                    margin-top: -10px;
                }
                .word {
                    text-align: right;
                    margin-right: 80px;
                    p:nth-child(1) {
                        font-size: 18px;
                        padding-bottom: 10px;
                        border-bottom: 1px solid #ccc;
                    }
                    p:nth-child(1)::after {
                        content: "";
                        position: absolute;
                        right: 2px;
                        margin-top: 20px;
                        width: 60px;
                        height: 3px;
                        background: #fabe00;
                    }
                    p:nth-child(2) {
                        font-size: 15px;
                        line-height: 22px;
                        color: #666;
                        margin-top: 10px;
                        // white-space: pre-line;
                        word-wrap: break-word;
                        word-break: break-all;
                    }
                    img {
                        width: 240px;
                        height: 110px;
                        margin-top: 10px;
                    }
                }
            }
            .main:nth-child(1) {
                margin-top: 300px;
            }
        }
        .Thread {
            position: absolute;
            top: 100px;
            left: 50%;
            width: 3px;
            .line {
                width: 100%;
                display: inline-block;
                z-index: 10;
                margin-top: 150px;
                height: 100px;
                background-color: #d1d1d1;
            }
        }
        .dexter {
            min-height: 500px;
            position: absolute;
            top: 0;
            left: 50%;
            box-sizing: border-box;
            border-left: 4px solid;
            border-image: linear-gradient(#fff, #8a8786, #fff) 1 10 1;
            .main {
                height: 500px;
                .car {
                    position: absolute;
                    left: -40px;
                }
                .word {
                    position: relative;
                    top: 20px;
                    margin-left: 80px;
                    p:nth-child(1) {
                        font-size: 18px;
                        padding-bottom: 10px;
                        border-bottom: 1px solid #ccc;
                    }
                    p:nth-child(1)::before {
                        content: "";
                        position: absolute;
                        top: 8px;
                        left: -75px;
                        width: 60px;
                        height: 3px;
                        background: #fabe00;
                    }
                    p:nth-child(2) {
                        font-size: 15px;
                        line-height: 22px;
                        color: #666;
                        margin-top: 10px;
                        // white-space: pre-line;
                        word-wrap: break-word;
                        word-break: break-all;
                    }
                    img {
                        width: 240px;
                        height: 110px;
                        margin-top: 10px;
                    }
                }
            }
            .main:nth-child(1) {
                margin-top: 30px;
            }
        }
    }
    .slide-fade-enter-active {
        transition: all 2s ease;
    }
    .slide-fade-enter {
        transform: translateY(300px);
        opacity: 0;
    }
}
</style>
